import styled from "styled-components";
import { useState, useEffect } from "react";

// Components
import Tabs from "./simulatorTasks/Tabs";
import ManagementCard from "./simulatorManagement/ManagementCard";

// Hooks
import useFetch from "../../../hooks/useFetch";

// Services.
import { getSimulatorUsers, getSimulators } from "./api/simulator";
import { useSelector } from "react-redux";

const SimulatorManagement = () => {

    const { ondemand_id } = useSelector((state) => state.auth.user);

    const [tabSelected, setTabSelected] = useState(0);
    const [filteredSimulators, setFilteredSimulators] = useState([]);

    const tabOptions = [
        { id: 0, label: "Asignados" },
        { id: 1, label: "Sin asignar" }
    ]

    const {
        data: fetchedUsers,
        loading,
        error
    } = useFetch({
        asyncFn: () => getSimulatorUsers(ondemand_id)
    })


    const {
        data: fetchedSimulators,
        loading: loadingSimulators,
        error: errorSimulators
    } = useFetch({
        asyncFn: getSimulators
    })

    useEffect(() => {
        if (fetchedSimulators) {
            console.info("fetchedSimulators", fetchedSimulators)
            const filteredSimulators = tabSelected === 0 
                ? fetchedSimulators?.filter(simulator => 
                    simulator?.run_codes?.length > 0 && 
                    simulator?.run_codes?.some(runCode => runCode?.sessions?.length > 0)
                  )
                : fetchedSimulators?.filter(simulator => 
                    simulator?.run_codes?.length === 0 || 
                    !simulator?.run_codes?.some(runCode => runCode?.sessions?.length > 0)
                  );
            setFilteredSimulators(filteredSimulators);
        }
    }, [tabSelected, fetchedSimulators]);

    return (
        <Container>
            <Tabs tabValue={tabSelected} handleTabValue={setTabSelected} tabOptions={tabOptions} />
            {
                (filteredSimulators?.length === 0 && !
                    loadingSimulators) && (
                    <h2 style={{ margin: " 2rem 1rem" }}>No hay simuladores asignados</h2>
                )
            }
            {
                loadingSimulators ? (
                    <h2 style={{ margin: " 2rem 1rem" }}>Cargando...</h2>
                ) : errorSimulators ? (
                    <h2 style={{ margin: " 2rem 1rem" }}>Error al cargar los simuladores</h2>
                ) : (
                    filteredSimulators?.map((simulator) => (
                        <ManagementCard
                            key={simulator?.id}
                            simulator={simulator}
                            users={{
                                data: fetchedUsers,
                                loading,
                                error
                            }} />
                    ))
                )
            }
        </Container>
    )
}

export default SimulatorManagement;

const Container = styled.div`
    width: calc(100% - 4rem);
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem 2rem;
`